// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"q8-z"};